import useIsInappWebview from "./useIsInappWebview";

// Fixed-bottom UI 의 padding-bottom CSS 표현 생성 (hook 버전, safeArea util 의
// React 인지 버전).
//
// 안전 영역 처리 분담 정책 (Distancing <-> inside-program):
//  - iOS in-app webview: WebView 가 화면 끝까지 닿음. RN 은 bottom 을 잡지
//    않고 web 의 env(safe-area-inset-bottom) 에 위임 (≈34px = ≈21 indicator + 13 breathing).
//    env(34) 자체로는 button 바닥이 safe-area boundary 와 0px 차이로
//    닿으므로 디자인상 추가 +4px breathing 을 더해 38px 로 띄움.
//  - iOS Safari / PC 브라우저 (PC 는 env=0 이므로 영향 없음): 동일하게
//    env() 가 정확히 보고되며 iOS 는 +4 동일 적용.
//  - Android in-app webview: Chromium 이 env() 를 0 으로 보고하기 때문에
//    Distancing 의 Webview.tsx / ActivityWebview.tsx 가 외부에서
//    paddingBottom: homeIndicatorHeight 로 안전영역을 직접 잡음.
//    그러나 RN 외부 padding 은 indicator/gesture bar 높이 만큼만 잡고 시각적
//    breathing 은 없으므로, 이 훅은 web 안쪽에서 16px 의 상대적
//    breathing 을 제공. iOS env(34)+4 와 시각적 유사.
//  - Android Chrome 등 외부 브라우저: env=0 이므로 minPx 가 fallback 으로
//    사용됨 (이 환경은 최적은 아니지만 회귀 위험 최소화 위해 기존 동작 유지,
//    iOS-only +4 는 적용하지 않음).
export default function useBottomSafePadding(minPx: string = "16px"): string {
  const isInappWebview = useIsInappWebview();
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const isAndroid = /android/i.test(ua);
  const isIos = /iPhone|iPad|iPod/i.test(ua);

  if (isInappWebview && isAndroid) {
    return "16px";
  }

  // iOS 는 env(34) boundary 와 button 바닥이 0px 이라 너무 붙어 보이므로
  // +4px breathing 추가 (디자인 요청). PC / Android Chrome 은 미적용.
  const extra = isIos ? " + 4px" : "";
  return `calc(max(env(safe-area-inset-bottom, 0px), ${minPx})${extra})`;
}
